import React from 'react';
import {
    BREAKPOINTS,
    BREAKPOINT_SIZES,
    getCurrentBreakpoint,
    isBreakpoint
} from 'tradera-utils/breakpoints';

// eslint-disable-next-line react/display-name
const mediumScreens = ComposedComponent => ({ breakpoint, ...props }) => {
    if (!breakpoint) {
        const current = getCurrentBreakpoint();
        breakpoint = BREAKPOINT_SIZES[current];
    }
    if (isBreakpoint(BREAKPOINTS.MD)) {
        return <ComposedComponent {...props} breakpoint={breakpoint} />;
    } else {
        return null;
    }
};

export default mediumScreens;
